<template>
  <span>
    <v-chip close small class="ml-2"
            @click:close="onClose(property)"
            v-for="(property, index) in properties"
            :key="index">
      {{ property.format(property) }}
    </v-chip>
  </span>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { isEmpty } from 'lodash';
import { CLEAR_FILTERS_PROPERTY } from '@/store/painel-cotacao/actions.type';

export default {
  data() {
    return {
      filterTypes: {
        valorMercadoria: {
          property: 'valorMercadoria',
          defaultValue: null,
          text: 'Valor maior que ',
          format(config) {
            return `${config.text} ${Vue.filter('currency')(config.value)}`;
          },
        },
        peso: {
          property: 'peso',
          defaultValue: null,
          text: 'Peso maior que ',
          format(config) {
            return `${config.text} ${config.value} kg`;
          },
        },
        municipiosColeta: {
          property: 'municipiosColeta',
          defaultValue: [],
          text: ' município(s) de coleta',
          format(config) {
            return `${config.value} ${config.text}`;
          },
        },
        municipiosEntrega: {
          property: 'municipiosEntrega',
          defaultValue: [],
          text: ' município(s) de entrega',
          format(config) {
            return `${config.value} ${config.text}`;
          },
        },
        estadosColeta: {
          property: 'estadosColeta',
          defaultValue: [],
          text: ' estado(s) de coleta',
          format(config) {
            return `${config.value} ${config.text}`;
          },
        },
        estadosEntrega: {
          property: 'estadosEntrega',
          defaultValue: [],
          text: ' estado(s) de entrega',
          format(config) {
            return `${config.value} ${config.text}`;
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters('painelCotacao', ['valorMercadoria', 'peso', 'municipiosColeta', 'estadosColeta', 'municipiosEntrega', 'estadosEntrega']),
    properties() {
      const selectedProperties = [];
      if (this.valorMercadoria) {
        selectedProperties.push(
          this.createProperty(this.valorMercadoria, this.filterTypes.valorMercadoria),
        );
      }
      if (this.peso) {
        selectedProperties.push(this.createProperty(this.peso, this.filterTypes.peso));
      }
      if (!isEmpty(this.municipiosColeta)) {
        selectedProperties.push(
          this.createProperty(this.municipiosColeta.length, this.filterTypes.municipiosColeta),
        );
      }
      if (!isEmpty(this.municipiosEntrega)) {
        selectedProperties.push(
          this.createProperty(this.municipiosEntrega.length, this.filterTypes.municipiosEntrega),
        );
      }
      if (!isEmpty(this.estadosColeta)) {
        selectedProperties.push(
          this.createProperty(this.estadosColeta.length, this.filterTypes.estadosColeta),
        );
      }
      if (!isEmpty(this.estadosEntrega)) {
        selectedProperties.push(
          this.createProperty(this.estadosEntrega.length, this.filterTypes.estadosEntrega),
        );
      }
      return selectedProperties;
    },
  },
  methods: {
    ...mapActions('painelCotacao', {
      clearFiltersAction: CLEAR_FILTERS_PROPERTY,
    }),
    createProperty(value, config) {
      return {
        value,
        ...config,
      };
    },
    onClose(config) {
      this.clearFiltersAction(config);
      this.$emit('change');
    },
  },
};
</script>
